var _classCallCheck = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var LogItem =
/*#__PURE__*/
function () {
  "use strict";

  function LogItem(date, level, message, meta, callback) {
    _classCallCheck(this, LogItem);

    this._date = date;
    this._level = level;
    this._message = message;
    this._meta = meta;
    this._callback = callback;
  }

  _createClass(LogItem, [{
    key: "date",
    get: function get() {
      return this._date;
    }
  }, {
    key: "level",
    get: function get() {
      return this._level;
    }
  }, {
    key: "message",
    get: function get() {
      return this._message;
    }
  }, {
    key: "meta",
    get: function get() {
      return this._meta;
    }
  }, {
    key: "callback",
    get: function get() {
      return this._callback;
    }
  }]);

  return LogItem;
}();

module.exports = LogItem;